export default {"src":"/_next/static/media/radio-light.a4006e64.svg","height":256,"width":256};